// Where a masterclass cover image comes from, in one place.
//
// The shelf used to be eleven variations of one drawing: public/images/
// mc-art-*.svg are all the same dark gradient, the same gold grid, the same
// gold glow and a thin gold line sketch. Individually they are fine. Eleven
// of them in a grid at thumbnail size are one texture, and a coach scanning
// the shelf cannot tell the passing class from the warmup class.
//
// The fix is not better drawings, it is real images. Eighteen modules already
// carry a `coverVideoId`, and Mux renders a frame from any playback id for
// free, which the drill cards, the content cards, the favourites list and the
// countdown takeover all already use. So every masterclass with a video can
// have a photograph of the actual session on it, different from every other
// one by construction, with no new asset to make or ship.
//
// Order, best first:
//
//   1. `poster`      a real photograph, hand picked, when one exists
//   2. a video frame from the module's own cover video
//   3. `thumb`       the generated SVG, kept as the floor so a class with
//                    neither a photo nor a video still has something
//
// Callers render the list and advance on error rather than taking the first
// entry, because a Mux id can 404 (asset deleted, id mistyped) and the art
// should degrade to the next option instead of to an empty box.

/** Mux renders a still from any public playback id. Shared so the crop,
 *  the fit mode and the default seek time cannot drift between surfaces. */
export function muxFrame(playbackId, { width = 640, height = 360, time } = {}) {
  if (!playbackId) return null;
  const t = time == null ? "" : `&time=${time}`;
  return `https://image.mux.com/${playbackId}/thumbnail.jpg`
    + `?width=${width}&height=${height}&fit_mode=smartcrop${t}`;
}

/**
 * Every cover candidate for one masterclass, best first, nulls dropped.
 *
 * `item` is the catalog card (mockData), `mod` the module it opens. A card
 * may set `posterTime` to pick a better second of the video: the default of
 * 8s skips an intro card or a fade up from black, but it is a guess and some
 * videos want a different one.
 */
export function coverSources(item = {}, mod = null, size = {}) {
  return [
    item.poster,
    muxFrame(mod?.coverVideoId || item.muxPlaybackId, {
      ...size,
      time: item.posterTime == null ? 8 : item.posterTime,
    }),
    item.thumb,
  ].filter(Boolean);
}
